<template>
  <span class="d-flex align-items-start">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div :class="'col-7 col-lg-12 status -' + statusColor">
      <FontAwesomeIcon :icon="'fa-light fa-' + statusIcon" />
      <span class="ms-2">{{ statusLabel }}</span>
    </div>
  </span>
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";
import { registrationConstante } from "@/constantes/registration";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "SortTableRegistrationStatusCellComponent",
  components: { FontAwesomeIcon, SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
  },
  emits: [],
  data() {
    return {};
  },
  computed: {
    statusLabel() {
      let translationParams = "";
      switch (this.status) {
        default:
        case registrationConstante.REGISTRATION_STATUS_UPCOMING:
          translationParams = "upcoming";
          break;
        case registrationConstante.REGISTRATION_STATUS_IN_PROGRESS:
          translationParams = "in_progress";
          break;
        case registrationConstante.REGISTRATION_STATUS_FINALIZED:
          translationParams = "finalised";
          break;
        case registrationConstante.REGISTRATION_STATUS_RUPTURE:
          translationParams = "break_up";
          break;
        case registrationConstante.REGISTRATION_STATUS_CANCELLED:
          translationParams = "cancelled";
          break;
      }
      return this.$t("registration.status." + translationParams);
    },
    statusColor() {
      switch (this.status) {
        default:
        case registrationConstante.REGISTRATION_STATUS_UPCOMING:
          return "primary";
        case registrationConstante.REGISTRATION_STATUS_IN_PROGRESS:
          return "secondary";
        case registrationConstante.REGISTRATION_STATUS_FINALIZED:
          return "success";
        case registrationConstante.REGISTRATION_STATUS_RUPTURE:
        case registrationConstante.REGISTRATION_STATUS_CANCELLED:
          return "danger";
      }
    },
    statusIcon() {
      switch (this.status) {
        default:
        case registrationConstante.REGISTRATION_STATUS_UPCOMING:
          return "clock";
        case registrationConstante.REGISTRATION_STATUS_IN_PROGRESS:
          return "play";
        case registrationConstante.REGISTRATION_STATUS_FINALIZED:
          return "check";
        case registrationConstante.REGISTRATION_STATUS_RUPTURE:
        case registrationConstante.REGISTRATION_STATUS_CANCELLED:
          return "ban";
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.status {
  padding: 5px 10px;
  border: 1px solid;
  border-radius: 6px;
  font-weight: 700;
  max-width: 120px;
  width: 100%;

  &.-success {
    border-color: $success;
    color: $success;
    background-color: $l-success;

    @include dark-theme {
      border-color: $l-success;
      color: $l-success;
      background-color: $success;
    }
  }
  &.-warning {
    border-color: $warning;
    color: $warning;
    background-color: $l-warning;

    @include dark-theme {
      border-color: $l-warning;
      color: $l-warning;
      background-color: $warning;
    }
  }
  &.-primary {
    border-color: $primary;
    color: $primary;
    background-color: $l-primary;

    @include dark-theme {
      border-color: $l-primary;
      color: $l-primary;
      background-color: $primary;
    }
  }
  &.-secondary {
    border-color: $secondary;
    color: $secondary;
    background-color: $l-secondary;

    @include dark-theme {
      border-color: $l-secondary;
      color: $l-secondary;
      background-color: $secondary;
    }
  }
  &.-danger {
    border-color: $danger;
    color: $danger;
    background-color: $l-danger;

    @include dark-theme {
      border-color: $l-danger;
      color: $l-danger;
      background-color: $danger;
    }
  }
}
</style>
